import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  Countdown,
  FONT_SIZES,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {memo} from 'react';
import {CouponExpiryDateCountdownUnitComponent} from '../../../../../features/Coupons/CouponExpiryDateCountdown/CouponExpiryDateCountdownUnitComponent';
import {getCouponExpiryDate} from '../../../../../features/Coupons/getCouponExpiryDate';

const CouponBadgeActiveCountdown: React.FC<{
  activatedCoupon?: Coupon | null;
  headline?: string;
}> = ({activatedCoupon, headline}) => {
  const {t} = useTranslation();

  if (headline) {
    return <>{headline}</>;
  }

  return (
    <>
      <Icon asset={GenericIconName.Clock} size="S" fill={COLORS.White} />
      <Label>{t('Time left:')}</Label>
      <StyledCountdown
        size="small"
        endDate={getCouponExpiryDate(activatedCoupon)!}
        unitComponent={StyledCountdownUnitComponent}
      />
    </>
  );
};

const Label = styled.span`
  white-space: nowrap;
`;

const StyledCountdown = styled(Countdown)`
  padding: 0;
  gap: 4px;
  border: none;
`;

const StyledCountdownUnitComponent = styled(
  CouponExpiryDateCountdownUnitComponent,
)`
  color: ${COLORS.White};
  font-size: ${FONT_SIZES.px10};
  text-transform: lowercase;
  padding: 0;
  line-height: 1;
`;

export const MemoCouponBadgeActiveCountdown = memo(CouponBadgeActiveCountdown);
